exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-sub{display:block;font-weight:400;font-size:10px;opacity:.85;line-height:1.2}[dir] .col-sub{margin-top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6de96faa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/report/gainedReport.vue
// module id = 1113
// module chunks = 0